import { jsx, jsxs } from "react/jsx-runtime";
function NoMedia() {
    return /*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 120 120",
        fill: "none",
        children: [
            /*#__PURE__*/ jsx("rect", {
                x: "6",
                y: "22",
                width: "100.5",
                height: "72",
                rx: "3",
                fill: "#EBEFF5"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M6 25C6 23.3431 7.34315 22 9 22H103.5C105.157 22 106.5 23.3431 106.5 25V31H6V25Z",
                fill: "#AFB9C9"
            }),
            /*#__PURE__*/ jsx("rect", {
                x: "18",
                y: "40.75",
                width: "31.5",
                height: "21",
                rx: "2.25",
                fill: "#D8DEEA"
            }),
            /*#__PURE__*/ jsx("rect", {
                x: "18",
                y: "69.25",
                width: "31.5",
                height: "3",
                rx: "1.5",
                fill: "#AFB9C9"
            }),
            /*#__PURE__*/ jsx("rect", {
                x: "18",
                y: "79.75",
                width: "18",
                height: "3",
                rx: "1.5",
                fill: "#AFB9C9"
            }),
            /*#__PURE__*/ jsx("circle", {
                cx: "20.625",
                cy: "26.875",
                r: "1.875",
                fill: "#EBEFF5"
            }),
            /*#__PURE__*/ jsx("circle", {
                cx: "13.875",
                cy: "26.875",
                r: "1.875",
                fill: "#EBEFF5"
            }),
            /*#__PURE__*/ jsx("circle", {
                cx: "27.375",
                cy: "26.875",
                r: "1.875",
                fill: "#EBEFF5"
            }),
            /*#__PURE__*/ jsx("rect", {
                width: "55",
                height: "48",
                rx: "3",
                transform: "matrix(-1 0 0 1 114 54)",
                fill: "#D8DEEA"
            }),
            /*#__PURE__*/ jsx("circle", {
                cx: "101.25",
                cy: "66.5",
                r: "4.5",
                fill: "#AFB9C9"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M95.7758 80.1749C96.6443 78.8396 98.5873 78.8049 99.503 80.1084L107.618 91.6608C108.666 93.1517 107.599 95.2041 105.777 95.2041H90.1476C88.3621 95.2041 87.2879 93.2241 88.2615 91.7273L95.7758 80.1749Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M78.9701 71.7707C79.8393 70.4413 81.7751 70.4067 82.6913 71.7041L96.7804 91.656C97.8328 93.1464 96.767 95.2039 94.9424 95.2039H67.8079C66.0199 95.2039 64.9462 93.2191 65.9247 91.7226L78.9701 71.7707Z",
                fill: "#EBEFF5"
            })
        ]
    });
}
export { NoMedia as default };
